import { Combiner } from '../components/Combiner';
import { Expression, FilterConfiguration } from '../types';
import { FilterValueInputType } from '../enum/FilterValueInputType';
import { Operation } from '../enum/Operation';
import { isMoment } from 'moment';
import { DateUtils } from '../../../utils/DateUtils';
import { FilterOperation, FilterOperator } from '../../../types/gql-types';

export class FilterMapper {
  mapToGQLFilters(combiner: Combiner, fieldConfig: FilterConfiguration[]): FilterOperator {
    return {
      operator: combiner.operator,
      subFilters: combiner.subFilters.map((element) => {
        if ('operator' in element) {
          return this.mapToGQLFilters(element, fieldConfig);
        }

        return this.mapOperation(element, fieldConfig);
      }),
    };
  }

  protected mapOperation(expression: Expression, fieldConfig: FilterConfiguration[]): FilterOperation {
    const output: FilterOperation = {
      field: expression.field,
      operation: expression.operation,
    };

    const field = this.getField(expression.field, fieldConfig);
    if (field === null) {
      output.value = this.mapValue(expression.value);
      return output;
    }

    // When dealing with SELECT options and contains, we are pushing elements into `values`
    if ([FilterValueInputType.SELECT, FilterValueInputType.AUTOCOMPLETE].includes(field.type) && expression.operation === Operation.CONTAINS) {
      output.values = Array.isArray(expression.value) ? expression.value : [expression.value.toString()];
    } else {
      output.value = this.mapValue(expression.value);
    }

    return output;
  }

  protected getField(name: string, fieldConfig: FilterConfiguration[]): FilterConfiguration | null {
    return fieldConfig.find((f) => f.filterKey === name) || null;
  }

  protected mapValue(value: Expression['value']): string {
    if (isMoment(value)) {
      return DateUtils.toISOString(value);
    }

    return value.toString();
  }
}
